import React, { createContext, useContext, useState, useEffect } from "react";

const StatutoryDetailsContext = createContext(null);

export function StatutoryDetailsProvider({ children }) {
  const [statutoryDetails, setStatutoryDetails] = useState(() => {
    try {
      const raw = sessionStorage.getItem("statutoryDetails");
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      console.warn("Failed to read statutoryDetails from sessionStorage", e);
      return null;
    }
  });

  useEffect(() => {
    try {
      if (statutoryDetails !== null) {
        sessionStorage.setItem("statutoryDetails", JSON.stringify(statutoryDetails));
      } else {
        sessionStorage.removeItem("statutoryDetails");
      }
    } catch (e) {
      console.warn("Failed to write statutoryDetails to sessionStorage", e);
    }
  }, [statutoryDetails]);

  const value = { statutoryDetails, setStatutoryDetails };

  return (
    <StatutoryDetailsContext.Provider value={value}>
      {children}
    </StatutoryDetailsContext.Provider>
  );
}

export function useStatutoryDetails() {
  const ctx = useContext(StatutoryDetailsContext);
  if (!ctx) {
    throw new Error("useStatutoryDetails must be used inside StatutoryDetailsProvider");
  }
  return ctx;
}
